<section>
  <div class="document-scoring-section__header">
    <xi-icon-button [icon]="icon()" (onClick)="toggleExpanded()"></xi-icon-button>

    <span>{{ header() }}</span>
  </div>

  <div
    class="document-scoring-section__content"
    [class.document-scoring-section__content--collapsed]="!isExpanded()"
  >
    <ng-content></ng-content>
  </div>
</section>
